import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { create } from "@/store";
import environment from "@/modules/environment";
import { dataSyncEmitter } from "@/modules/events/emitter";

const initialState: DevicesState = {
  devices: {}
};

const useDevices = create<DevicesStore>()(
  persist(
    immer((set, get) => ({
      ...initialState,
      updatePairedDevice(device) {
        log.devices("updating device", device);
        if (!device.jid) return;
        set(({ devices }) => {
          const updatedDevice = {
            ...(devices[device.jid] || {}),
            ...device
          };
          if (device.settings)
            (updatedDevice as StoreCameraDevice).settings = {
              ...(devices as StoreCameraDevices)[device.jid]?.settings,
              ...device.settings
            };

          devices[device.jid] = updatedDevice as StoreDevice;
        });
      },
      updateExistingDevice(device) {
        if (!device.jid) return;
        const doesExist = device.jid in get().devices;
        if (!doesExist) {
          log.err("Trying to update nonexisting device", device);
          return;
        }
        log.devices("updating existing device", device);
        set(({ devices }) => {
          const updatedDevice = {
            ...(devices[device.jid] || {}),
            ...device
          };
          if (device.settings)
            (updatedDevice as StoreCameraDevice).settings = {
              ...(devices as StoreCameraDevices)[device.jid]?.settings,
              ...device.settings
            };

          devices[device.jid] = updatedDevice as StoreDevice;
        });
      },
      removePairedDevice(jid) {
        log.devices("removing device", jid);
        const device = get().devices[jid];
        set(({ devices }) => {
          delete devices[jid];
        });
        dataSyncEmitter.emit("device-removed", device);
      },
      resetState() {
        log.devices("resetting devices store");
        set(initialState);
      }
    })),
    {
      name: environment.appMode + "-devices"
    }
  )
);

export { useDevices };
